module.exports = __webpack_public_path__ + "img/Co-curriculam.3d131898.png";